import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const lockSurfaceNodeForUpdateMutation = gql`
  mutation lockSurfaceNodeForUpdate($id: ID!) {
    lockSurfaceNodeForUpdate(id: $id) {
      error
      success
    }
  }
`;

export default mutation(lockSurfaceNodeForUpdateMutation);
